import helper from '@/lib/helper'

export const theWolfQuiz = {
    "code": "",
    "title": "The Wolf Quiz",
    "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/eb39aaf70273977e31.jpeg?r=02642",
    "image_original": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/5c65e3d02e63c39419.webp?r=08560",
    "image_placeholder": "no-image1.png",
    "image_source": "",
    "image_coordinates": [],
    "video": null,
    "description": "The Wolf Quiz\" is an engaging and educational challenge designed to test your knowledge about wolves. ",
    "custom_message": "",
    "is_random_question_order": true,
    "background_color": "#ef0000",
    "background_image": null,
    "background_image_original": "",
    "background_image_source": "",
    "background_image_coordinates": [],
    "background_image_blur": 0,
    "background_image_darken": 30,
    "background_image_opacity": 70,
    "background_video": "",
    "background_type": "color",
    "background_music": {
        "id": 0,
        "name": "",
        "src": "",
        "is_playing": "",
        "volume": 0
    },
    "type": "quiz",
    "show_result_on_user_device": false,
    "questions": [{
        "uid": helper.randomUid(),
        "title": "What is a common way wolves communicate with each other?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "",
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "By changing their fur color",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "By howling",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "By dancing",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Q: What is a common way wolves communicate with each other?<br>A: By changing their fur color<br>B: By howling<br>C: By dancing<br>Crr: B"
    }, {
        "uid": helper.randomUid(),
        "title": "What is the average size of a wolf pack in the wild?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/9293814884522d2150.jpeg?r=08409",
        "image_source": "http://commons.wikimedia.org/wiki/File:Timber_wolves_fighting.jpg",
        "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/9ad250188942e3083d238aebdb7c68ff.jpg",
        "image_coordinates": {
            "width": 1826.7051773207895,
            "height": 1826.7051773207895,
            "top": 115.41964003367258,
            "left": 611.9336792088743
        },
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "2-3 wolves",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "6-8 wolves",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "15-20 wolves",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Q: What is the average size of a wolf pack in the wild?<br>A: 2-3 wolves<br>B: 6-8 wolves<br>C: 15-20 wolves<br>Crr: B"
    }, {
        "uid": helper.randomUid(),
        "title": "What is the primary diet of a wolf in the wild?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "",
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "Fruits and nuts",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "Fish and seaweed",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "Large mammals like deer and elk",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Sure! Here's a multiple-choice question about wolves:<br>Q: What is the primary diet of a wolf in the wild?<br>A: Fruits and nuts<br>B: Fish and seaweed<br>C: Large mammals like deer and elk<br>Crr: C"
    }, {
        "uid": helper.randomUid(),
        "title": "What is a unique way that wolves communicate with each other over long distances?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "",
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "By howling in harmony",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "By whistling",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "By drumming on trees",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "By dancing in circles",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Q: What is a unique way that wolves communicate with each other over long distances?<br>A: By howling in harmony<br>B: By whistling<br>C: By drumming on trees<br>D: By dancing in circles<br>Crr: A"
    }, {
        "uid": helper.randomUid(),
        "title": "What do wolves like to do in their free time?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "https://media0.giphy.com/media/pMguhq2183BiQi9nZB/200.gif?cid=ebe0a748te99xe5756otmw5q5h3kj1zsy7qoi3m2qzuhd32a&ep=v1_gifs_search&rid=200.gif&ct=g",
        "image_original": "https://media0.giphy.com/media/pMguhq2183BiQi9nZB/200.gif?cid=ebe0a748te99xe5756otmw5q5h3kj1zsy7qoi3m2qzuhd32a&ep=v1_gifs_search&rid=200.gif&ct=g",
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "Play fetch with sticks",
            "image": "",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choices": [],
                "accepted_percentage": 0,
                "completely_correct": true
            }
        }, {
            "title": "Howl at the moon",
            "image": "",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choices": [],
                "accepted_percentage": 0,
                "completely_correct": true
            }
        }, {
            "title": "Dance in the forest",
            "image": "",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choices": [],
                "accepted_percentage": 0,
                "completely_correct": true
            }
        }, {
            "title": "Take selfies with other animals",
            "image": "",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choices": [],
                "accepted_percentage": 0,
                "completely_correct": true
            }
        }]
    }],
    "approval_status": "",
    "tags": [],
    "countries": [],
    "age": [0, 99],
    "difficult": 5,
    "limit_player": 10,
    "show_number_question": "5",
    "show_correct_answer": true,
    "playing_counter": 0,
    "class_subject": null,
    "class_grade": [],
    "show_school_list": false,
    "show_school_country_list": false,
    "school_id": null,
    "status": false,
    "theme_name": "theme_1",
    "themes": {
        "theme_1": {
            "name": "theme_1",
            "question_text_color": "#ffffff",
            "question_shadow_color": "#0c343d",
            "button_text_color": "#134f5c",
            "ui_color": "#ffffff",
            "button_color": "#ffffff",
            "background_image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/cb883674da219ce813.jpeg?r=06514",
            "background_image_source": "",
            "background_image_original": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/9be5ee9be4ee2db290.webp?r=00867",
            "background_image_coordinates": [],
            "background_color": "#134f5c"
        },
        "theme_2": {
            "name": "theme_2",
            "question_text_color": "#000000",
            "question_shadow_color": "",
            "button_text_color": "#ffffff",
            "ui_color": "#21B6A8",
            "button_color": "#18A558",
            "background_image": "",
            "background_image_source": "",
            "background_image_original": "",
            "background_image_coordinates": [],
            "background_color": "#cc0000"
        },
        "theme_3": {
            "name": "theme_3",
            "question_text_color": "#000000",
            "question_shadow_color": "",
            "button_text_color": "#ffffff",
            "ui_color": "#B8860B",
            "button_color": "#FF8C00",
            "background_image": "",
            "background_image_source": "",
            "background_image_original": "",
            "background_image_coordinates": [],
            "background_color": "#cc0000"
        }
    },
    "captcha_response": "",
    "share_setting": {
        "can_read": false,
        "can_edit": false,
        "can_access_report": false,
    }
}
